module.exports = __webpack_public_path__ + "ab44a937ebcabaa2bb3d12832268bb60.png";